import { IContext } from 'overmind';
import {
  // createConnect,
  createStateHook,
  createActionsHook,
  createEffectsHook,
  createReactionHook,
} from 'overmind-react';
import { merge, namespaced } from 'overmind/config';

import * as api from './api';
import * as auth from './auth';
import * as session from './session';
import * as account from './account';
import * as payment from './payment';
import * as auction from './auction';
import * as collection from './collection';
import * as smartLink from './smart-link';
import * as feed from './feed';
import * as rate from './rate';
import * as error from './error';
import * as bid from './bid';
import * as search from './search';
import * as analytics from './analytics';
import * as publisher from './publisher';
import * as date from './date';
import * as graph from './graph';
import * as order from './order';
import * as product from './product';
import * as megatable from './megatable';
import * as actions from './actions';

export const config = merge(
  { actions },
  namespaced({
    api,
    auth,
    session,
    account,
    payment,
    auction,
    collection,
    smartLink,
    feed,
    rate,
    error,
    bid,
    search,
    analytics,
    publisher,
    date,
    order,
    product,
    megatable,
    graph,
  }),
);

export type Context = IContext<typeof config>;

export const useAppState = createStateHook<Context>();
export const useActions = createActionsHook<Context>();
export const useEffects = createEffectsHook<Context>();
export const useReaction = createReactionHook<Context>();

// export const useOvermind: any = createHook<typeof config>();

// this is an older way using a HoC to hook in class-based components
// export const connect: any = createConnect<typeof config>();
